<ion-header>
  <app-header></app-header>
</ion-header>
<ion-content [fullscreen]="true">
  <div class="calls-wrap page-width">
    <div class="title">{{ "__CALLS_MANAGER_DASHBOARD__" | translate }}</div>
    <app-calls-cards-advanced
      *ngIf="topStatistics"
      [userType]="'manager'"
      [cards]="cards"
      [statistic]="topStatistics"
    ></app-calls-cards-advanced>

    <div class="export-wrap">
      <app-calls-filter
        [configs]="selectors"
        (valueChange)="onSelectorsChange($event)"
      ></app-calls-filter>

      <app-calls-export
        [isIncludeTeams]="isIncludeTeams"
        [getPayload]="getPayload.bind(this)"
        (valueChange)="onSelectorsChange($event)"
      ></app-calls-export>
    </div>

    <div class="tabs-container">
      <div
        class="tab"
        *ngFor="let tab of tabs"
        [class.active]="selectedTab === tab.id"
        (click)="selectTab(tab.id)"
      >
        {{ tab.label | translate }}
      </div>
      <div
        class="tab"
        *ngIf="filteredCallsList"
        [class.active]="selectedTab === 'callslog'"
        (click)="selectTab('callslog')"
      >
        {{ "__CALLS_CALLS_LOG__" | translate }}
      </div>
    </div>

    <div class="tab-content">
      <ng-container [ngSwitch]="selectedTab">
        <div *ngSwitchCase="'learners'">
          <app-calls-table
            *ngIf="learnersStatistic"
            [columns]="tableColumns"
            [rawData]="learnersStatistic"
            [userType]="'manager'"
            (rowClicked)="openLearnerStatistic($event)"
          ></app-calls-table>
        </div>
        <div *ngSwitchCase="'scorecard'">
          <app-calls-scorecard
            *ngIf="sectionStats"
            [userType]="'manager'"
            [scenarios]="allScenarios"
            [data]="sectionStats"
          ></app-calls-scorecard>
        </div>
        <div *ngSwitchCase="'heatmap'">
          <app-calls-heatmap
            *ngIf="sectionStats"
            [userType]="'manager'"
            [scenarios]="allScenarios"
            [data]="sectionStats"
          ></app-calls-heatmap>
        </div>
        <div *ngSwitchCase="'callslog'" class="user-overview">
          <app-user-calls-overview
            *ngIf="filteredCallsList && !showLearnerDetails"
            [callList]="filteredCallsList"
            (viewRecord)="viewRecord($event)"
          >
          </app-user-calls-overview>

          <app-call-details
            *ngIf="showLearnerDetails"
            [data]="callDetails"
            (doGoBack)="handleBack()"
          ></app-call-details>
        </div>
        <div *ngSwitchDefault>{{ "__CALLS_NO_CONTENT__" | translate }}</div>
      </ng-container>
    </div>
  </div>
</ion-content>
